import _             from 'lodash'
import moment        from 'moment'
import React         from 'react'
import * as Table    from 'reactabular-table'
import * as resolver from 'table-resolver'

import { Alert, Button, Glyphicon, FormControl, ButtonToolbar } from 'react-bootstrap'
import { DateTimePicker                                       } from 'react-widgets'
import Confirm                                                  from 'react-confirm-bootstrap'

import { formatDate } from 'alto-utils/lib/utils'

import Select        from './select'
import BooleanSelect from './boolean_select'
import GlyphButton   from './glyph_button'

import './admin_table.sass'

removeEmptyAttrs = (obj) ->
  new ->
    for attr, val of obj
      @[attr] = val unless [undefined, null, '', [], {}].includes(val)
    @

# FIXME: this is too big, extract logic into helper classes
# TODO: memoize columns

# requirements:
# - callback props:
#   - onCreate, onUpdate, onDelete
#   - onChange - notifies parent that ordering or filters were changed
# - attributes:
#   - required - model, defaultFilters
#   - optional - additionalTableClasses, idColumn, actionsColumn
# - methods:
#   - rows(), columns()
export default class AdminTable extends React.Component
  constructor: (props, context) ->
    super(props, context)

    @globalActions = @globalActions.bind(@)
    @actionsFor    = @actionsFor.bind(@)
    @orderable     = @orderable.bind(@)

    @state =
      ready: true
      notReadyMessage: ''
      ordering: @constructor.defaultOrdering ? props.primaryKey
      filters:  @defaultFilters

  @defaultProps: { primaryKey: 'id' }

  # override these
  rows:    -> @props.records
  columns: -> throw 'all subclasses of AdminTable must implement the columns() method'

  idColumn: true
  actionsColumn: true
  allowCreate: true
  allowEdit: true
  allowDelete: true
  defaultFilters: { 'id': '' }
  additionalTableClasses: 'two-actions'
  defaultTableClasses:
    'admin-table table table-striped table-condensed table-hover table-fixed vertical-align-center'


  # call these from parent component
  getOrdering: ->
    @state.ordering

  getFilters: ->
    _.mapKeys(removeEmptyAttrs(@state.filters), (v, property) => @_filterFor(property))


  # call these from column header formatters
  orderable: (label, { property, column }) ->
    @_orderLinkFor(label, property, column)

  filterable: (options = {}) ->
    (label, { property, column }) =>
      <div>
        {label}
        {@_filterInputFor(property, column, options)}
      </div>

  orderableAndFilterable: (options = {}) ->
    (label, { property, column }) =>
      <div>
        {@_orderLinkFor(label, property, column)}
        {@_filterInputFor(property, column, options)}
      </div>


  render: ->
    if @state.ready
      <Table.Provider columns={@_columns()} className={@_tableClasses()}>
        <Table.Header />
        <Table.Body rows={@_rows()} rowKey={@props.primaryKey} />
      </Table.Provider>
    else
      <Alert>{@state.notReadyMessage}</Alert>


  globalActions: ->
    <ButtonToolbar className='pull-right'>
      {@resetFiltersButton()}
      {@createButton() if @allowCreate}
    </ButtonToolbar>

  actionsFor: (pk) ->
    <ButtonToolbar className='pull-right'>
      {@editButton(pk)   if @allowEdit}
      {@deleteButton(pk) if @allowDelete}
    </ButtonToolbar>


  createButton: ->
    <GlyphButton onClick={@props.onCreate}        glyph='plus' bsStyle='success' bsSize='xsmall' />

  editButton: (pk) ->
    <GlyphButton onClick={=> @props.onUpdate(pk)} glyph='edit' bsStyle='warning' bsSize='xsmall' />

  resetFiltersButton: ->
    <GlyphButton onClick={@_resetFilters}     glyph='asterisk' bsStyle='primary' bsSize='xsmall' />

  deleteButton: (pk) ->
    <Confirm title={"Odstranit #{@model.accusativeName}"}
      body={"Skutečně chcete odstranit #{@model.accusativeName} #{pk}?"}
      confirmText="Odstranit"
      cancelText="Neodstraňovat"
      onConfirm={=> @props.onDelete(pk)}>

      <Button bsStyle='danger' bsSize='xsmall'><Glyphicon glyph='remove'/></Button>
    </Confirm>


  _rows: ->
    resolver.resolve(columns: @_columns(), method: resolver.nested)(@rows())

  _columns: ->
    columns = @columns()

    idColumn =
      property: @props.primaryKey
      header:
        label: 'ID'
        props: { className: 'id-column' }
        formatters: [@orderableAndFilterable()]
      filter:
        matcher: 'icontains'

    actionsColumn =
      property: @props.primaryKey
      header:
        props: { className: 'actions-column' }
        formatters: [@globalActions]
      cell:
        formatters: [@actionsFor]

    columns = [idColumn].concat(columns)    if @idColumn
    columns = columns.concat(actionsColumn) if @actionsColumn

  _tableClasses: ->
    [@defaultTableClasses, @additionalTableClasses, _.kebabCase(@constructor.name)].join(' ')

  _filterFor: (property) ->
    column  = @_filterableColumnFor(property)
    key     = column.filter.property or property
    matcher = column.filter.matcher

    if (not matcher?) or matcher == 'exact' then key else key + '.' + matcher

  _filterableColumnFor: (property) ->
    column = _.find(@_columns(), (column) ->
      column.filter? and (column.property == property or column._property == property))

    column or throw new Error("couldn't find filterable column for #{property}")

  _changeOrdering: (property) ->
    ordering = if @state.ordering == property then '-' + property else property

    @setState(ordering: ordering, @props.onChange)

  _submitFilter: ->
    @props.onChange()

  _changeFilter: (property, value) ->
    unless @state.filters[property] == value
      @setState(filters: @_addFilter(property, value))

  _changeAndSubmitFilter: (property, value) ->
    unless @state.filters[property] == value
      @setState(filters: @_addFilter(property, value), @props.onChange)

  _addFilter: (property, value) ->
    _.assign({}, @state.filters, { "#{property}": value })

  _resetFilters: =>
    # TODO: this should be smarter
    # - in most cases the subclass doesn't provide default filters, since they are empty
    # - this should go through specs and use correct null values for all kinds of filters
    @setState(filters: @defaultFilters, @props.onChange)

  _orderLinkFor: (label, property, column) ->
    property = @_propertyFor(property, column)
    handler  = (event) =>
      event.preventDefault()
      @_changeOrdering(property)

    if @state.ordering == property
      indicator = <Glyphicon glyph='triangle-top' />
    else if @state.ordering == '-' + property
      indicator = <Glyphicon glyph='triangle-bottom' />

    <a href='' onClick={handler}>{label} {indicator}</a>

  _filterInputFor: (property, column, options) ->
    property = @_propertyFor(property, column)
    type     = options.type or 'text'

    switch type
      when 'text'
        <FormControl type="text" value={@state.filters[property] ? ''}
         onChange={(e)   => @_changeFilter(property, e.target.value)}
         onKeyPress={(e) => @_submitFilter() if e.key == 'Enter'} />
      when 'select'
        <Select options={options.options} allowBlank={true}
         onChange={(value) => @_changeAndSubmitFilter(property, value)} />
      when 'boolean_select'
        <BooleanSelect onChange={(value) => @_changeAndSubmitFilter(property, value)} />
      when 'date'
        onChange = (value) => @_changeAndSubmitFilter(property, formatDate(moment(value)))

        <DateTimePicker time={false} onChange={onChange}
         onKeyPress={(event) => onChange(event.target.value) if event.key == 'Enter'}/>

  _propertyFor: (property, column) ->
    unless _.isString(property) or _.isString(column._property)
      throw new Error('invalid property')

    if _.isString(property) then property else column._property
